import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { ButtonGroup } from '@mui/material'
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined'
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined'
import AddCardOutlinedIcon from '@mui/icons-material/AddCardOutlined'
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined'
import SidebarAction from '/components/sidebar-action'

import { AppContext } from '/providers/app-context'

const Menu = () => {

  const navigate = useNavigate()
  const { client } = useContext(AppContext)

  const page = location.pathname.split("/").pop()

  return (
    <div className='flex flex-row justify-between'>
      <div />
      <ButtonGroup variant="text" aria-label="Actions">
        {client.billing_mode === "prepay" && 
        <>
          <SidebarAction label="Credit Management" icon={<AddCardOutlinedIcon />} active={page === "credit-management"} onClick={() => navigate("../credit-management")} />
        </>}

        <SidebarAction label="Invoices" icon={<ReceiptLongOutlinedIcon />} active={page === "invoices"} onClick={() => navigate("../invoices")} />
        <SidebarAction label="Credit Usage" icon={<CreditCardOutlinedIcon />} active={page === "credit-usage"} onClick={() => navigate("../credit-usage")} />

        {client.billing_mode === "prepay" && 
        <>
          <SidebarAction label="Payment Card" icon={<CreditCardOutlinedIcon />} active={page === "payment-card"} onClick={() => navigate("../payment-card")} />
          <SidebarAction label="Apply for contract plan" icon={<AccountBalanceOutlinedIcon />} active={page === "credit-plan"} onClick={() => navigate("../credit-plan")} />
        </>}

        {client.billing_mode === "postpay" && 
        <>
          <SidebarAction label="Direct Debit" icon={<AccountBalanceOutlinedIcon />} active={page === "direct-debit"} onClick={() => navigate("../direct-debit")} />
        </>}
      </ButtonGroup>
    </div>

  )
}

export default Menu
